import { Outlet } from "react-router-dom";
import { useRouteParams } from "src/hooks/useRouteParams";
import { useDevelopmentAllLotsQuery } from "src/routes/developments/DevelopmentAllLots.generated";
import { DevelopmentContextProvider } from "src/routes/developments/context/DevelopmentContext";
import { DevelopmentParams } from "src/routes/routesDef";
import { queryResult } from "src/utils/queryResult";

/**
 * Development domain context layout for the data router.
 *
 * Role: data router pathless layout. Fetches the development, provides `DevelopmentContext`, renders `<Outlet />`.
 * SideNav chrome and leaf routes are declared in `src/routing/domains/developments/` — this file has no `<Route>`s.
 * Sits above Beam and legacy chrome wrappers so context stays mounted across those branches.
 */
export function DevelopmentLayout() {
  const { developmentId } = useRouteParams<DevelopmentParams>();
  const query = useDevelopmentAllLotsQuery({ variables: { developmentId } });

  return queryResult(query, {
    data: (data) => {
      const lotsAcquired = data.cohorts.flatMap((c) => c.projects).length;
      return (
        <DevelopmentContextProvider
          id={developmentId}
          featureFlags={data.development.featureFlags.map((ff) => ff.type.code)}
          name={data.development.name}
          lotsAcquired={lotsAcquired}
          key={developmentId}
        >
          <Outlet />
        </DevelopmentContextProvider>
      );
    },
    showLoading: "always",
  });
}
